import { getBaseApiUrl } from './core';

export const postFeedback = async (token, feedbackData) => {
    try {
        const response = await fetch(`${getBaseApiUrl()}feedback`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(feedbackData)
        });

        if (!response.ok) {
            let errorMessage = 'Failed to submit feedback';
            const errorText = await response.text();
            if (errorText) {
                try {
                    const errorData = JSON.parse(errorText);
                    errorMessage = errorData.error || errorMessage;
                } catch (error) {
                    errorMessage = errorText;
                }
            }
            throw new Error(errorMessage);
        }

        return await response.json();
    } catch (error) {
        console.error('Error submitting feedback:', error);
        return { error: error.message };
    }
};

export const getAdminFeedback = async (token, page = 0, size = 20) => {
    try {
        const response = await fetch(`${getBaseApiUrl()}feedback/admin?page=${page}&size=${size}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch feedback');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching admin feedback:', error);
        return { error: error.message };
    }
};

export const deleteFeedback = async (token, feedbackId) => {
    try {
        const response = await fetch(`${getBaseApiUrl()}feedback/admin/${feedbackId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Failed to delete feedback');
        }

        return { success: true };
    } catch (error) {
        console.error('Error deleting feedback:', error);
        return { error: error.message };
    }
};
